import { render, staticRenderFns } from "./CidsCard.vue?vue&type=template&id=4db3194a&scoped=true"
import script from "./CidsCard.vue?vue&type=script&lang=js"
export * from "./CidsCard.vue?vue&type=script&lang=js"
import style0 from "./CidsCard.vue?vue&type=style&index=0&id=4db3194a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3194a",
  null
  
)

export default component.exports